import React, { FC } from 'react';

export const PrivacyFooter: FC = () => {
    return <>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10px", flexShrink: 0}}>
            <div style={{ fontSize: "0.7rem", marginBottom: "5px" }}>
                <b>Powered by i3 Verticals</b>
            </div>
            <nav aria-label="Legal">
                <ul style={{listStyle: "none", padding: 0, margin: 0, display: "flex", gap: "0.5em"}}>
                    <li>
                        <a className="policy-links"
                            target='_blank'
                            rel="noreferrer"
                            href="https://www.i3verticals.com/terms-of-use/">
                            Terms of Use
                        </a>
                    </li>
                    <li> | </li>
                    <li>
                        <a className="policy-links"
                            target='_blank'
                            rel="noreferrer"
                            href="https://www.i3verticals.com/privacypolicy/">
                            Privacy Policy
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </>
}
